'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10 0c5.556 0 10 4.444 10 10s-4.444 10-10 10S0 15.556 0 10 4.444 0 10 0ZM3.825 14.76 8.585 10l-4.76-4.76A7.773 7.773 0 0 0 2.222 10c0 1.802.596 3.45 1.603 4.76Zm1.414 1.415A7.773 7.773 0 0 0 10 17.778c1.802 0 3.45-.596 4.76-1.603L10 11.415l-4.76 4.76h-.001Zm9.522-12.35A7.773 7.773 0 0 0 10 2.222c-1.802 0-3.45.596-4.76 1.603L10 8.585l4.76-4.76h.001Zm1.414 1.414L11.415 10l4.76 4.76A7.773 7.773 0 0 0 17.778 10c0-1.802-.596-3.45-1.603-4.76v-.001Z",
    fill: "currentColor"
  }));
});
var MissingOutline = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.MissingOutline = MissingOutline;